
import { getBoxValue } from './utils/functions';
import { getBackgroundCSS, getTypoCSS, getShadowCSS } from '../../Components/utils/getCSS';

const Style = ({ attributes }) => {
	const { cId, wrapperBgColor, wrapperPadding, cardBackground, cardPadding, cardBorder, cardRadius, cardShadow, cardHoverShadow, secondaryBg, quoteIconColor, nameTypo, nameColor, nameHoverColor, imgBgColor, imgBorder, imgPadding, imgRadius, imgShadow, timeTypo, timeColor, reviewTextTypo, reviewTextColor, columnGap, rowGap, postedTextColor, postedTextTypo, postedAuthor, postedAuthorTypo, showBtnColor, showBtnHoverColor } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS('', nameTypo)?.googleFontLink}
		${getTypoCSS('', reviewTextTypo)?.googleFontLink}
		${getTypoCSS('', timeTypo)?.googleFontLink}
		${getTypoCSS('', postedTextTypo)?.googleFontLink}
		${getTypoCSS('', postedAuthorTypo)?.googleFontLink}

		${getTypoCSS(`#grbbBusinessReview-${cId} .singleWrap .authorName`, nameTypo)?.styles}
		${getTypoCSS(`#grbbBusinessReview-${cId} .singleWrap .reviewText p`, reviewTextTypo)?.styles}
		${getTypoCSS(`#grbbBusinessReview-${cId} .singleWrap .reviewTime`, timeTypo)?.styles}
		${getTypoCSS(`#grbbBusinessReview-${cId} .singleWrap .providedBy p`, postedTextTypo)?.styles}
		${getTypoCSS(`#grbbBusinessReview-${cId} .singleWrap .providedBy a`, postedAuthorTypo)?.styles}
		
		#grbbBusinessReview-${cId} {
			${getBackgroundCSS(wrapperBgColor)};
			padding: ${getBoxValue(wrapperPadding)};
		}
		#grbbBusinessReview-${cId} .grbbBusinessReview{
			grid-gap: ${rowGap} ${columnGap};
		}
		#grbbBusinessReview-${cId} .reviewCard {
			${getBackgroundCSS(cardBackground)};
			padding: ${getBoxValue(cardPadding)};
			border: ${getBoxValue(cardBorder)};
			border-radius: ${cardRadius};
			box-shadow: ${getShadowCSS(cardShadow)};
			transition: 0.3s;
		}
		#grbbBusinessReview-${cId} .reviewCard:hover {
			box-shadow: ${getShadowCSS(cardHoverShadow)};
			transition: 0.3s;
		}
		#grbbBusinessReview-${cId} .grid2Single .reviewCard .angel {
			${getBackgroundCSS(cardBackground)}
		}
		#grbbBusinessReview-${cId} .grid2Single .reviewCard::after {
			left: calc(40px - ${cardBorder?.width});
			border: calc(8px + ${cardBorder?.width}) solid transparent;
			border-top: calc(14px + ${cardBorder?.width}) solid ${cardBorder?.color};
		}
		#grbbBusinessReview-${cId} .singleWrap .grid3Heading {
			${getBackgroundCSS(secondaryBg)};
		}
		#grbbBusinessReview-${cId} .singleWrap .grid3Heading:before{
			color:${quoteIconColor}
		}
		#grbbBusinessReview-${cId} .singleWrap .authorName{
			color:${nameColor};
		}
		#grbbBusinessReview-${cId} .singleWrap .authorName:hover{
			color:${nameHoverColor};
		}
		#grbbBusinessReview-${cId} .singleWrap .img img{
			background:${imgBgColor};
			border:${getBoxValue(imgBorder)};
			border-radius: ${imgRadius};
			box-shadow: ${getShadowCSS(imgShadow)};
			padding:${getBoxValue(imgPadding)};
		}

		#grbbBusinessReview-${cId} .grid4Single .reviewCard .img::after, #grbbBusinessReview-${cId} .grid4Single .reviewCard .img::before {
			background:${imgBorder.color}
		}
		#grbbBusinessReview-${cId} .singleWrap .reviewTime{
			color:${timeColor};
		}
		#grbbBusinessReview-${cId} .singleWrap .reviewText p{
			color:${reviewTextColor};
		}
		#grbbBusinessReview-${cId} .singleWrap .providedBy p{
			color:${postedTextColor};
		}
		#grbbBusinessReview-${cId} .singleWrap .providedBy a{
			color:${postedAuthor};
		}
		#grbbBusinessReview-${cId} .expandedBtn {
			color:${showBtnColor};
		}
		#grbbBusinessReview-${cId} .expandedBtn:hover {
			color:${showBtnHoverColor}
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;